import { useFeatureFlags } from 'src/hooks';

const useCertificatesText = (documentsType: 'certificate' | 'resume') => {
  const { featureEnableNewTalentOnboarding } = useFeatureFlags();

  if (!featureEnableNewTalentOnboarding) {
    return 'Resume, Certifications and More';
  }
  if (documentsType === 'resume') {
    return 'Resume';
  }
  return 'Credentials & Supporting Documents';
};

export default useCertificatesText;
